import React, { useCallback } from "react";
import { Dropdown, MenuProps } from "antd";
import { useNavigate } from "react-router-dom";
import { editTrapPath } from "../components/Map/TrapsiteEditor/openTrapEditor";

/**
 * Right-click "Edit Trap" for anything that lists devices.
 *
 * The editor itself lives on the map, so this navigates there with the trap
 * named in the URL rather than trying to host a second copy of it. Matching
 * the pattern UsersTable already uses for row context menus.
 */
export const useEditTrapMenu = () => {
  const navigate = useNavigate();

  const open = useCallback(
    (deviceUuid: string) => navigate(editTrapPath(deviceUuid)),
    [navigate],
  );

  const menuFor = useCallback(
    (deviceUuid: string): MenuProps => ({
      items: [
        {
          key: "edit-trap",
          label: "Edit Trap",
          onClick: () => open(deviceUuid),
        },
      ],
    }),
    [open],
  );

  /**
   * Wraps a table row. The Dropdown suppresses the browser menu itself, so
   * there is deliberately no competing onRow contextmenu handler.
   */
  const wrapRow = useCallback(
    (deviceUuid: string | undefined, props: any) =>
      deviceUuid ? (
        <Dropdown menu={menuFor(deviceUuid)} trigger={["contextMenu"]}>
          <tr {...props} />
        </Dropdown>
      ) : (
        <tr {...props} />
      ),
    [menuFor],
  );

  return { menuFor, wrapRow, open };
};
